<template>
	<div>
		<el-dialog append-to-body :title="$t('purchaseOrder.title')" :visible="isShowPurchase" class="purchase-dialog"
			:before-close="purchaseClose" style="margin: 0 auto;" width="90%">
			<el-carousel arrow="always" :autoplay="false" indicator-position="outside" class="picsCard" trigger="click"
				ref="dialog" @change="dialogchange">
				<el-carousel-item v-for="(item, index) in purchaseorder" :key="item + index" :label="item.custname">
					<el-tabs v-model="activeName" type="card" style="width: 90%;margin: 0 auto;">
						<el-tab-pane :label="$t('purchaseOrder.purchasetabs[0]')" name="first">
							<el-form :model="item" ref="item" :inline="true" label-width="145px" class="demo-shopform"
								style="overflow: hidden;overflow-y: scroll;height: 550px;">
								<el-form-item :label="$t('subscribe.labellist[3]')" prop="num"><el-input
										v-model="item.num" disabled></el-input></el-form-item>

								<el-form-item :label="$t('subscribe.labellist[6]')" prop="custname"><el-input
										v-model="item.custname" disabled></el-input></el-form-item>

								<el-form-item :label="$t('subscribe.labellist[2]')" prop="applydt" v-if="false">
									<el-date-picker value-format="yyyy-MM-dd" v-model="item.applydt" type="date"
										disabled style="width: 200px;"></el-date-picker>
								</el-form-item>

								<el-form-item :label="$t('subscribe.labellist[16]')" prop="ShipmanDate"
									:rules="{ required: true, message: $t('subscribe.labellist[16]') + ' ' + $t('depart.msg[1]') }">
									<el-date-picker value-format="yyyy-MM-dd" :disabled="isLooka == true"
										v-model="item.ShipmanDate" type="date"
										:style="item.status == 1 && item.purchaseState == 0 ? 'width: 135px;' : 'width: 200px;'"></el-date-picker>
									<el-button size="mini" type="primary"
										v-if="item.status == 1 && item.purchaseState == 0" @click="checkDate(item)">
										{{ $t('purchase.condition[1]') }}
									</el-button>
								</el-form-item>

								<el-form-item :label="$t('purchase.tablelist[5]')"
									:rules="{ required: true, message: $t('purchase.tablelist[5]') + ' ' + $t('depart.msg[1]') }">
									<el-select v-model="item.Payment" :disabled="isLooka == true"
										:placeholder="$t('SupplierClass.placeholder')" style="width: 200px;">
										<el-option v-for="(item, index) in paymentList" :key="index"
											:label="item.PaymentName" :value="item.PaymentName"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item :label="$t('purchase.tablelist[3]')"><el-input v-model="item.money"
										disabled></el-input></el-form-item>

								<el-form-item :label="$t('purchase.tablelist[17]')" v-if="false">
									<el-input v-model="item.VatRate" type="number" max="20" min="0"
										:disabled="isLooka == true" style="width: 200px;"></el-input>
								</el-form-item>

								<el-form-item :label="$t('purchase.tablelist[21]')"><el-input v-model="item.Tax"
										disabled></el-input></el-form-item>

								<el-form-item :label="$t('purchase.tablelist[18]')"><el-input v-model="item.totalAmount"
										disabled></el-input></el-form-item>

								<el-form-item :label="$t('purchase.tablelist[4]')">
									<el-input type="number" v-model="item.discount" :disabled="item.purchaseState>=1"
										@blur="discountInput(item)"></el-input>
								</el-form-item>

								<el-form-item :label="$t('subscribe.labellist[7]')"
									:rules="{ required: true, message: $t('subscribe.errmsg[1]') }">
									<el-select v-model="item.currencyid" @change="currencyChange"
										:disabled="isLooka == true" :placeholder="$t('SupplierClass.placeholder')"
										style="width: 200px;">
										<el-option v-for="(item, index) in currlist" :key="index" :label="item.ShortEng"
											:value="item.id"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label="$t('GoodsList.dialog[14]')"><el-input v-model="item.purclass"
										disabled></el-input></el-form-item>

								<el-form-item :label="$t('subscribe.labellist[0]')" v-if="isEdita == true"><el-input
										v-model="item.optname" disabled></el-input></el-form-item>
								<el-form-item :label="$t('subscribe.labellist[0]')" v-if="isEdita == false"><el-input
										v-model="base_name" disabled></el-input></el-form-item>
								<!-- <el-form-item :label="$t('subscribe.labellist[1]')"><el-input v-model="base_deptname" disabled></el-input></el-form-item> -->

								<el-form-item :label="$t('subscribe.labellist[4]')" prop="explain">
									<el-input type="textarea" v-model="item.explain" style="width:555px"
										v-if="isLooka == false"></el-input>
									<el-input type="textarea" v-model="item.explain" style="width:555px" disabled
										v-if="isLooka == true"></el-input>
								</el-form-item>

								<el-form-item label="" class="formtable" style="width:100%;">
									<el-table :empty-text="$t('header.tableEmpty')" stripe border :data="item.GoodsList"
										style="width: 100%">
										<el-table-column>
											<template slot="header" slot-scope="scope">
												<div style="display:flex;">
													<!-- <span>{{ $t('subscribe.labellist[8]') }}：</span> -->
													<el-button type="primary"
														@click="filesOut(item.GoodsList)">{{ $t('GoodsList.filesout') }}</el-button>
												</div>
											</template>

											<el-table-column :label="$t('subscribe.labellist[9]')" width="100"
												prop="Goods.num" show-overflow-tooltip align="center">
												<template slot-scope="scope">
													<span style="cursor: pointer; color: #409EFF; text-decoration: underline;"
														@click="handleCellClick(scope.row)">{{ scope.row.Goods.num }}</span>
												</template>
											</el-table-column>

											<el-table-column :label="$t('subscribe.labellist[10]')" width="100"	prop="Goods.name" show-overflow-tooltip	align="center"></el-table-column>

											<el-table-column :label="$t('subscribe.labellist[36]')" width="100"	prop="Goods.localDes" show-overflow-tooltip	align="center"></el-table-column>

											<el-table-column :label="$t('subscribe.labellist[17]')" width="100"
												prop="BaseCount" align="center"></el-table-column>

											<el-table-column :label="$t('subscribe.labellist[11]')" width="100"
												prop="count">
												<template slot-scope="scope">
													<el-input type="number" v-model="scope.row.count"
														style="width: 100%;" v-if="isLooka == false" min="1"></el-input>
													<el-input type="number" v-model="scope.row.count" disabled
														style="width: 100%;" v-if="isLooka == true" min="1"></el-input>
												</template>
											</el-table-column>

											<el-table-column align="center" width="140"
												:label="$t('subscribe.labellist[19]')" prop="requestReason"
												show-overflow-tooltip>
												<template slot-scope="scope">
													<el-input type="text" v-model="scope.row.requestReason"
														style="width: 100%;" v-if="isLooka == false"></el-input>
													<div v-if="isLooka == true">{{ scope.row.requestReason }}</div>
													<!-- <el-input type="text" v-model="scope.row.requestReason" disabled
														style="width: 100%;" v-if="isLooka == true"></el-input> -->
												</template>
											</el-table-column>

											<el-table-column :label="$t('subscribe.labellist[12]')" prop="Goods.unit"
												show-overflow-tooltip align="center"></el-table-column>

											<el-table-column :label="$t('GoodsList.dialog[4]')" width="110" prop="price"
												:formatter="tableFormat" show-overflow-tooltip align="center">
												<template slot-scope="scope">
													<el-input type="text" v-model="scope.row.price" style="width: 100%;"
														:disabled="item.status!=0" @blur="changePrice"
														min="0"></el-input>
												</template>
											</el-table-column>

											<el-table-column :label="$t('purchase.tablelist[3]')" width="110"
												prop="totalAmount" :formatter="tableFormat" show-overflow-tooltip
												align="center"></el-table-column>

											<el-table-column :label="$t('purchase.tablelist[17]')" width="110"
												prop="VatRate" show-overflow-tooltip align="center">
												<template slot-scope="scope">
													<el-input type="number" v-model="scope.row.VatRate"
														style="width: 100%;" v-if="isLooka == false" min="0"
														max="20"></el-input>
													<el-input type="number" v-model="scope.row.VatRate" disabled
														style="width: 100%;" v-if="isLooka == true" min="0"
														max="20"></el-input>
												</template>
											</el-table-column>

											<el-table-column :label="$t('purchase.tablelist[21]')"
												:formatter="tableFormat" width="100" prop="Tax" show-overflow-tooltip
												align="center"></el-table-column>

											<el-table-column align="center" :label="$t('GoodsList.dialog[21]')"
												width="120" prop="Goods.NeedInspect"
												show-overflow-tooltip></el-table-column>

											<el-table-column align="center" :label="$t('purchase.tablelist[19]')"
												width="120" prop="PQInfo" show-overflow-tooltip></el-table-column>

											<el-table-column align="center" :label="$t('purchase.tablelist[20]')"
												width="100" prop="FromDepart" show-overflow-tooltip></el-table-column>

											<!-- <el-table-column align="center" :label="$t('GoodsList.dialog[23]')" width="100" prop="Goods.AccountNO" show-overflow-tooltip></el-table-column> -->

											<!-- <el-table-column align="center" :label="$t('GoodsList.dialog[27]')" width="110" prop="Goods.explain" show-overflow-tooltip></el-table-column> -->
											<el-table-column width="100" v-if="isdeleteitem == true">
												<template slot-scope="scope">
													<el-button type="primary" :disabled="item.GoodsList.length <= 1"
														@click="deleteItemFunc(scope.row, item)">
														{{ $t('GoodsList.deleteitem') }}
													</el-button>
												</template>
											</el-table-column>

											<el-table-column width="100" v-if="item.id === 0 || item.id === null">
												<template slot-scope="scope">
													<el-button type="primary" :disabled="item.GoodsList.length <= 1"
														@click="deleteItemBeforeCreate(scope.row, item)">
														{{ $t('GoodsList.deleteitem') }}
													</el-button>
												</template>
											</el-table-column>
										</el-table-column>
									</el-table>
								</el-form-item>
							</el-form>
						</el-tab-pane>

						<el-tab-pane :label="$t('purchaseOrder.purchasetabs[1]')" name="second">
							<el-input class="showText" v-html="item.remark" type="textarea" disabled
								style="width: 100%; white-space: pre-wrap;" :autosize="{ minRows: 5, maxRows: 30 }"
								v-model="item.remark"></el-input>
						</el-tab-pane>

						<el-tab-pane :label="$t('purchaseOrder.purchasetabs[2]')" name="third" v-if="isEdita == true">
							<el-upload style="display:flex;width:auto;" class="uploadc" :action="uploadFileURL"
								:data="uploadData" :show-file-list="false" :on-remove="filesChange"
								:on-preview="clickFiles" :on-success="filesSuccess" :before-remove="fileDelete"
								:disabled="isLooka == true">
								<div style="display: flex;justify-content: space-around;height: 100%;">
									<div
										style="display: flex;justify-content: flex-start;align-items: center;flex-direction: column;margin-top: 20px;">
										<el-button size="small" type="primary"
											v-if="isLooka == false">{{ $t('GoodsList.dialog[11]') }}</el-button>
									</div>
									<div class="uploadTable"
										style="width: 65%;margin: auto 0;height: 100%;overflow: hidden;overflow-y: scroll;">
										<el-table :empty-text="$t('header.tableEmpty')" :data="item.attachList" stripe
											:show-header="false" style="width: 100%">
											<el-table-column prop="name">
												<template slot-scope="scope">
													<span
														style="margin-right: 10px;font-size:15px;">{{ scope.row.filename }}</span>
													<i class="el-icon-circle-check" style="color:#67C23A;"></i>
												</template>
											</el-table-column>
											<el-table-column prop="download">
												<template slot-scope="scope">
													<el-link type="primary" icon="el-icon-download"
														style="font-size:15px;" @click.stop="clickFiles(scope.row)">
														{{ $t('GoodsList.dialog[12]') }}
													</el-link>
												</template>
											</el-table-column>
											<!-- <el-table-column prop="name">
														<template slot-scope="scope">
															<span style="margin-right: 10px;font-size:15px;">删除</span>
														</template>
													</el-table-column> -->
										</el-table>
									</div>
								</div>
							</el-upload>
						</el-tab-pane>

						<el-tab-pane :label="$t('purchaseOrder.purchasetabs[3]')" name="fourth">
							<el-input class="showText" v-html="item.operaHistory" type="textarea" disabled
								style="width: 100%; white-space: pre-wrap;" :autosize="{ minRows: 5, maxRows: 30 }"
								v-model="item.operaHistory"></el-input>
						</el-tab-pane>
					</el-tabs>
				</el-carousel-item>
			</el-carousel>
			<div style="display: flex;justify-content: flex-end;">
				<el-button type="primary" @click="submitShop('item')"
					v-if="isLooka == false">{{ $t('GoodsList.submitBtn') }}</el-button>
				<el-button type="primary" @click="audit()"
					v-if="isnotify == true && isLooka == true">{{ $t('audit.buttons[1]') }}</el-button>
			</div>
		</el-dialog>

		<picture-swiper :filesList.sync="currentGoods.picsList" :showPreview.sync="isShowPreview"
			@closeSwiper="FcloseSwiper"></picture-swiper>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import bus from '../bus';
	import wmsApi from '@/request/wmsApi';
	import baseDataApi from '@/request/baseDataApi';
	import xlsxTool from '@/utils/xlsxTool';
	import PictureSwiper from "@/components/common/PurchasingManagement/PictureSwiper";
	export default {
		name: 'AddPurchaseOrder',
		components: {
			PictureSwiper
		},
		props: {
			purchaseorder: {
				required: true,
				default: () => [],
				type: Array
			},
			isShowPurchase: {
				required: true,
				default: false,
				type: Boolean
			},
			isEdita: {
				required: false,
				default: false,
				type: Boolean
			},
			isLooka: {
				required: false,
				default: false,
				type: Boolean
			},
			isnotify: {
				required: false,
				default: false,
				type: Boolean
			},
			isdeleteitem: {
				required: false,
				default: false,
				type: Boolean
			},
			auditid: {
				required: false,
				default: 0,
				type: Number
			}
		},
		data() {
			return {
				base_name: '',
				base_deptname: '',
				tableData: [],
				currlist: [],
				purchaseClass: [],
				paymentList: [],
				uploadData: {},
				fileList: [],
				purchaseorder1: [],

				activeName: 'first',

				// 图片预览
				currentGoods: {},
				isShowPreview: false
			};
		},
		mounted() {
			if (this.userData === null || this.userData === undefined) return;

			this.base_name = this.userData.user;
			this.base_deptname = this.userData.deptname;

			this.getCurrencyList();
			this.getPurchaseClass();
			this.GetPaymentList();
			console.log('console.log(this.purchaseorder);', this.purchaseorder);
		},
		methods: {
			handleCellClick(row) {
				this.currentGoods = row.Goods;
				if (row.Goods.picsList && row.Goods.picsList.length > 0) {
					this.isShowPreview = true;
				} else {
					this.isShowPreview = false;
					this.$message({
						message: this.$t("GoodsList.msg[10]"),
						type: "warning"
					});
				}
			},

			FcloseSwiper() {
				this.isShowPreview = false;
			},

			deleteItemBeforeCreate(row, order) {
				console.log('row', row);
				console.log('order', order);
				for (let i = 0; i < order.GoodsList.length; i++) {
					if (order.GoodsList[i].aid === row.aid) {
						order.GoodsList.splice(i, 1);
					}
				}

				for (let i = 0; i < order.detailList.length; i++) {
					if (order.detailList[i].goodsid === row.aid) {
						order.detailList.splice(i, 1);
					}
				}
			},

			async checkDate(getitem) {
				var that = this;

				getitem.purchaseState = 1;
				let checkdateRes = await wmsApi.CreateOrEditPurchase(this.token, [getitem]);
				if (checkdateRes.resultCode === 0) {
					that.$message({
						message: that.$t('purchase.condition[1]') + ' ' + that.$t('GoodsList.msg[0]'),
						type: 'success'
					});
				} else {
					that.$confirm(submitGoodsRes.errMsg, that.$t('purchase.condition[1]') + ' ' + that.$t(
							'GoodsList.msg[1]'), {
							showCancelButton: false,
							type: 'warning'
						})
						.then(() => {})
						.catch(() => {});
				}
			},

			filesOut(scope) {
				console.log(scope);
				let tmpArr = [];
				scope.forEach(item => {
					let tmpObj = {
						itemNum: item.Goods.num,
						itemName: item.Goods.name,
						OriginallyQty: item.BaseCount,
						Quantity: item.count,
						RequestReason: item.requestReason,
						Unit: item.Goods.unit,
						UnitPrice: item.price,
						Amount: item.totalAmount,
						VATRate: item.VatRate,
						VATAmount: item.Tax,
						needtoinspect: item.Goods.NeedInspect,
						'Requisitionno#': item.PQInfo,
						DeptDemand: item.FromDepart
					};
					tmpArr.push(tmpObj);
				});
				xlsxTool.exportFile(tmpArr, 'Purchase order checking purpose.xlsx');
			},

			async deleteItemFunc(item, item1) {
				console.log(item, item1);
				console.log(item.Goods.id, item1.num);
				var that = this;

				this.$confirm(that.$t('purchase.deleteitem'), this.$t('header.tishi'), {
						confirmButtonText: this.$t('header.confirmButtonText'),
						cancelButtonText: this.$t('header.cancelButtonText'),
						type: 'warning'
					})
					.then(async () => {
						let sucRes = await wmsApi.InvalidPurchaseInfo(this.token, item1.num, item.id);
						if (sucRes.resultCode === 0) {
							that.$message({
								message: that.$t('GoodsList.deleteitem') + ' ' + that.$t(
									'GoodsList.msg[0]'),
								type: 'success'
							});
							that.$emit('closePurchase');
							that.purchaseorder = [];
							that.purchaseorder1 = [];
							that.fileList = [];
							that.activeName = 'first';
						} else {
							that.$confirm(submitGoodsRes.errMsg, that.$t('GoodsList.deleteitem') + ' ' + that
									.$t('GoodsList.msg[1]'), {
										showCancelButton: false,
										type: 'warning'
									})
								.then(() => {})
								.catch(() => {});
						}
					})
					.catch(() => {});
			},

			async GetPaymentList() {
				this.paymentList = [];
				let sucRes = await baseDataApi.GetPaymentList();
				if (sucRes.resultCode === 0) {
					this.paymentList = sucRes.data;
				}
			},

			async getPurchaseClass() {
				this.purchaseClass = [];
				let sucRes = await baseDataApi.GetPurchaseClass(this.token);
				if (sucRes.resultCode === 0) {
					this.purchaseClass = sucRes.data;
				}
			},

			async getCurrencyList() {
				this.currlist = [];
				let sucRes = await baseDataApi.GetCurrencyList();
				if (sucRes.resultCode === 0) {
					this.currlist = sucRes.data;
				}
			},

			currencyChange() {
				this.currlist.forEach(currobj => {
					if (currobj.id == this.purchaseorder.currencyid) {
						this.purchaseorder.currencyid = currobj.id;
						this.purchaseorder.shortEng = currobj.ShortEng;
					}
				});
			},

			discountInput(e) {
				// console.log(e);
				// e.sourceMoney = e.sourceMoney.replace(',','');
				// console.log(e.sourceMoney, e.discount);
				e.money = e.sourceMoney - e.discount;
			},

			changePrice(e) {

			},

			purchaseClose(done) {
				this.$confirm(this.$t('header.confirm'), this.$t('header.tishi'), {
						confirmButtonText: this.$t('header.confirmButtonText'),
						cancelButtonText: this.$t('header.cancelButtonText'),
						type: 'warning'
					})
					.then(() => {
						this.$emit('closePurchase');
						this.purchaseorder = [];
						this.fileList = [];
						this.activeName = 'first';
						done();
					})
					.catch(() => {});
			},

			dialogchange() {
				this.activeName = 'first';
			},

			changeVatRate(e) {
				if (e.VatRate === 0) {
					e.totalAmount = e.money;
				} else {
					e.totalAmount = e.money + (e.money * e.VatRate) / 100;
				}
			},

			async submitShop() {
				var countine = true;
				// console.log('purchaseorder.GoodsList',this.purchaseorder.GoodsList);
				this.purchaseorder.forEach((orderobj, index) => {
					if (orderobj.ShipmanDate == null || orderobj.ShipmanDate == '') {
						this.$message({
							message: this.$t('purchaseOrder.purchasetabs[4]') +
								' ' +
								(index + 1) +
								' ' +
								this.$t('purchaseOrder.purchasetabs[5]') +
								' ' +
								this.$t('subscribe.labellist[16]') +
								' ' +
								this.$t('depart.msg[1]'),
							type: 'warning'
						});
						countine = false;
						return;
					}

					if (orderobj.Payment == null || orderobj.Payment == '') {
						this.$message({
							message: this.$t('purchaseOrder.purchasetabs[4]') +
								' ' +
								(index + 1) +
								' ' +
								this.$t('purchaseOrder.purchasetabs[5]') +
								' ' +
								this.$t('purchase.tablelist[5]') +
								' ' +
								this.$t('depart.msg[1]'),
							type: 'warning'
						});
						countine = false;
						return;
					}

					if (orderobj.currencyid == null || orderobj.currencyid == '') {
						this.$message({
							message: this.$t('purchaseOrder.purchasetabs[4]') +
								' ' +
								(index + 1) +
								' ' +
								this.$t('purchaseOrder.purchasetabs[5]') +
								' ' +
								this.$t('subscribe.labellist[7]') +
								' ' +
								this.$t('depart.msg[1]'),
							type: 'warning'
						});
						countine = false;
						return;
					}
				});

				if (countine == false) {
					return;
				}

				let tmpPurchaseList = Object.assign([], this.purchaseorder);
				// console.log('purchaseorder', this.purchaseorder);
				// console.log('purchaseorder1', tmpPurchaseList);
				// Object.assign(tmpPurchaseList, this.purchaseorder);
				// tmpPurchaseList.forEach((obj, index) => {
				// 	obj.GoodsList.forEach(goodsobj => {
				// 		goodsobj.Goods = '';
				// 	});
				// });
				let loading = this.$loading();
				let resList = [];
				let errMsg = '';
				for (let i = 0; i < tmpPurchaseList.length; i++) {
					let submitGoodsRes = await wmsApi.CreateOrEditPurchase(this.token, [tmpPurchaseList[i]]);
					resList.push(submitGoodsRes);
					errMsg += `${submitGoodsRes.errMsg};`;
				}
				loading.close();
				let success = true;
				resList.forEach(item => {
					if (item.resultCode !== 0) success = false;
				});
				if (success) {
					// loading.close();
					this.$message({
						message: errMsg,
						type: 'success'
					});
					this.$emit('closePurchase');
					this.purchaseorder = [];
					this.purchaseorder1 = [];
					this.fileList = [];
					this.activeName = 'first';
				} else {
					// loading.close();
					this.$confirm(errMsg, this.$t('GoodsList.submitBtn') + ' ' + this.$t('GoodsList.msg[1]'), {
							showCancelButton: false,
							type: 'warning'
						})
						.then(() => {
							this.$emit('closePurchase');
							this.purchaseorder = [];
							this.purchaseorder1 = [];
							this.fileList = [];
							this.activeName = 'first';
						})
						.catch(() => {});
				}
			},

			filesSuccess(res, file, fileList) {
				// console.log('res', res);
				// console.log('file', file);
				this.$message({
					message: this.$t('GoodsList.upload') + ' ' + this.$t('GoodsList.msg[0]'),
					type: 'success'
				});
				this.purchaseorder[0].attachList.push(file.response.data);
				this.purchaseorder[0].attachList = this.purchaseorder[0].attachList;
			},

			filesChange(file, fileList) {
				this.purchaseorder[0].attachList = fileList.slice(-3);
				// console.log('fileList', fileList);
			},

			clickFiles(file) {
				var token = this.token;
				let downUrl = wmsApi.GetDownloadUrl(this.token, file.id);
				window.open(downUrl);
			},

			fileDelete(file, fileList) {
				return false;
			},

			tableFormat(row, column, cellValue, index) {
				if (column.label == this.$t('GoodsList.dialog[4]')) {
					if (row.price) {
						row.price += '';
						if (!row.price.includes('.')) row.price += '.';
						return row.price
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ',';
							})
							.replace(/\.$/, '');
					}
				}

				if (column.label == this.$t('GoodsList.dialog[28]')) {
					if (row.totalAmount) {
						row.totalAmount += '';
						if (!row.totalAmount.includes('.')) row.totalAmount += '.';
						return row.totalAmount
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ',';
							})
							.replace(/\.$/, '');
					}
				}

				if (column.label == this.$t('purchase.tablelist[21]')) {
					if (row.Tax) {
						row.Tax += '';
						if (!row.Tax.includes('.')) row.Tax += '.';
						return row.Tax.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
							return $1 + ',';
						}).replace(/\.$/, '');
					}
				}

				return cellValue;
			},

			async audit() {
				let appid = [];
				appid.push(this.auditid);
				let submitRes = await wmsApi.ApprovalRequest(this.token, appid, '', 1);
				console.log('submitRes: ', submitRes);

				if (submitRes.resultCode === 0) {
					this.$message({
						message: this.$t('GoodsList.submitBtn') + ' ' + this.$t('GoodsList.msg[0]'),
						type: 'success'
					});
					this.$emit('closePurchase');
				} else {
					this.$confirm(submitRes.errMsg, this.$t('header.tishi'), {
						confirmButtonText: this.$t('header.confirmButtonText'),
						cancelButtonText: this.$t('header.cancelButtonText'),
						type: 'warning'
					});
				}
			}
		},
		computed: mapState({
			userData: state => state.user.userData,
			token: state => state.user.token,
			uploadFileURL() {
				return wmsApi.GetUploadUrl(this.token, this.purchaseorder[0].id ? this.purchaseorder[0].id : 0,
					'purchase');
			}
		}),
		watch: {
			// isShowSubscribe(newVal, oldVal) {
			// 	if (newVal) this.getDepartBudgetInfo();this.base_deptname = this.userData.deptname;this.base_deptnameid = this.userData.deptid;
			// }//no
		}
	};
</script>

<style>
	.formtable .el-form-item__content {
		width: 100%;
	}

	.purchase-dialog .el-dialog {
		margin-top: 5vh !important;
		height: 850px;
	}

	.purchase-dialog::-webkit-scrollbar {
		width: 0 !important;
	}

	.showText .el-textarea__inner:disabled {
		color: #000000;
	}

	.el-input.is-disabled .el-input__inner {
		color: #000000;
	}

	.picsCard .el-carousel__container {
		height: 600px;
	}

	.picsCard .el-carousel__container .el-carousel__arrow--left {
		left: 0px;
	}

	.picsCard .el-carousel__container .el-carousel__arrow--right {
		right: 0px;
	}

	/* .picsCard .el-carousel__container .el-carousel__indicators--outside button{
		background-color: #0000FF !important;
	} */
	.picsCard .el-carousel__button {
		background-color: #414141 !important;
	}

	.uploadc .el-upload--text {
		width: 100%;
		margin-right: 30px;
		height: 300px;
	}

	.uploadForm .el-form-item__content {
		display: flex;
		justify-content: space-around;
	}

	.uploadTable::-webkit-scrollbar {
		width: 0 !important;
	}

	.picsCard .el-carousel__button {
		/* background-color: red !important; */
		color: white !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/PurchasingManagement/AddPurchaseOrder.vue